import { useQuery } from 'react-query';

import { GetSubsetFactsResponse } from '../../../../backend/src/matter/subset/dto/response-get-subset.facts.dto';
import { FactFilters } from '../../types';
import { APIBaseChronos } from '@/api/hosts';
import { QueryEntity } from '@/api/types';
import useGetFetchConfig, { FetchMethod } from '@/api/useGetFetchConfig';
import { createFilterBody } from '@/helpers/createFilterParams';

interface GetSubsetFactsProps {
  matterId: string;
  subsetId: string;
  searchQuery?: string;
  page?: number;
  pageSize?: number;
  paginated: boolean;
  filters: FactFilters;
}

function useGetSubsetFacts({
  matterId,
  subsetId,
  searchQuery,
  filters,
  page,
  pageSize,
  paginated,
}: GetSubsetFactsProps) {
  const { getFetchConfig } = useGetFetchConfig();
  const fetchConfigPOST = getFetchConfig({
    method: FetchMethod.POST,
    data: {
      searchQuery: searchQuery || '',
      page: page || 1,
      pageSize: pageSize || 50,
      ...createFilterBody(filters),
      paginated,
    },
  });

  return useQuery<GetSubsetFactsResponse, Error>(
    [QueryEntity.SubsetFacts, { subsetId, searchQuery, filters, page, pageSize }],
    async () => {
      const response = await fetch(`${APIBaseChronos}/api/matter/${matterId}/subset/${subsetId}/facts`, {
        ...fetchConfigPOST,
      });
      if (!response.ok) throw new Error('Network response was not ok');
      return response.json();
    },
    {
      refetchOnWindowFocus: false,
    },
  );
}

export default useGetSubsetFacts;
